<template>
  <div>
    <v-card-actions>
      <v-card-title class="text_box">
        <div v-for="platform in getProjectPlatforms" :key="platform.id">
          <v-chip color="primary" close @click:close="deletePlatform(platform)">
            {{ platform.platform_name }}
          </v-chip>
        </div>
      </v-card-title>
    </v-card-actions>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectPlatformView",
  computed: {
    ...mapGetters(["getProjectPlatforms"]),
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "DeleteProjectPlatform",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async deletePlatform(value) {
      await this.showLoadingProcess();
      try {
        const id = {id: value.id};
        await this.DeleteProjectPlatform(id);
        await this.closeLoading();
        await this.showSnackBar({
          text: `${value.platform_name} has been removed from Project`,
          color: DEFAULT_CONSTANTS.warn,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        await this.showSnackBar({
          text: "Delete Failed",
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
  },
};
</script>

<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
